import { Fragment, type ReactNode } from 'react';

/**
 * Texto da resposta do assistente.
 *
 * A resposta chega em texto simples, com listas por hifen e negrito por asteriscos
 * duplos. Ela e montada como elementos, e nunca como HTML: um trecho com marcacao
 * vindo do motor de linguagem aparece como texto, e nao vira codigo na pagina.
 */
export function AssistantText({ text }: { text: string }) {
  const blocos = text
    .split(/\n{2,}/)
    .map((bloco) => bloco.trim())
    .filter(Boolean);

  return (
    <div className="flex flex-col gap-2">
      {blocos.map((bloco, indice) => {
        const linhas = bloco.split('\n');
        const lista = linhas.every((linha) => /^\s*[-*]\s+/.test(linha));
        if (lista) {
          return (
            <ul key={indice} className="flex list-disc flex-col gap-1 pl-5">
              {linhas.map((linha, i) => (
                <li key={i}>{negrito(linha.replace(/^\s*[-*]\s+/, ''))}</li>
              ))}
            </ul>
          );
        }
        return (
          <p key={indice}>
            {linhas.map((linha, i) => (
              <Fragment key={i}>
                {i > 0 ? <br /> : null}
                {negrito(linha.replace(/^\s*#+\s+/, ''))}
              </Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}

function negrito(linha: string): ReactNode[] {
  return linha
    .split(/(\*\*[^*]+\*\*)/g)
    .map((parte, i) =>
      parte.startsWith('**') && parte.endsWith('**') && parte.length > 4 ? (
        <strong key={i}>{parte.slice(2, -2)}</strong>
      ) : (
        <Fragment key={i}>{parte}</Fragment>
      ),
    );
}
